<template>
    <div class="settings-page">
        <div class="container container--mw-xxxl settings-page__container">
            <h1 class="settings-page__heading">Account Settings</h1>

            <div class="row justify-content-between settings-page__row">
                <div class="col settings-page__column">
                    <h2 class="settings-page__form-heading">Change your password</h2>

                    <FormulateForm @submit="changePassword" class="formulate-form">
                        <p v-if="changePasswordSuccessMsg" class="body-copy body-copy--align-center">Password has been changed</p>
                        <p v-if="changePasswordErrorMsg"  class="body-copy body-copy--align-center body-copy--color-error">Changing password Failed</p>

                        <FormulateInput
                            type="password"
                            name="oldpassword"
                            v-model="oldpassword"
                            label="Old Password"
                            validation="required"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <FormulateInput
                            type="password"
                            name="password"
                            v-model="newpassword"
                            label="New Password"
                            validation="required|matches:/[!@$%^&*#?\-_{}[\]()+=~.]/|min:8"
                            :validation-messages="{matches: 'Passwords must include at least one number and one special character.'}"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <FormulateInput
                            type="password"
                            name="password_confirm"
                            v-model="confirmpassword"
                            label="Confirm New Password"
                            validation="required|matches:/[!@$%^&*#?\-_{}[\]()+=~.]/|min:8|confirm"
                            :validation-messages="{matches: 'Passwords must include at least one number and one special character.'}"
                            validation-name="Password confirmation"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <div class="formulate-form__form-footer">
                            <FormulateInput
                                type="submit"
                                name="Change Password"
                                :disabled="changePasswordIsActive"
                                :input-class="'btn'"
                            />
                        </div>
                    </FormulateForm>
                </div>

                <div class="col settings-page__column">
                    <h2 class="settings-page__form-heading">Change your account details</h2>

                    <FormulateForm @submit="changeDetails" class="formulate-form">
                        <FormulateInput
                            type="text"
                            name="name"
                            v-model="username"
                            label="Name"
                            validation="required"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <FormulateInput
                            type="email"
                            name="email"
                            v-model="useremail"
                            label="Email"
                            validation="required"
                            validation-name="Email"
                            :wrapper-class="['formulate-input-wrapper--container']"
                            :label-class="['formulate-input-label--contained']"
                            :element-class="['formulate-input-element--contained']"
                        />

                        <div class="formulate-form__form-footer">
                            <FormulateInput
                                type="submit"
                                name="Change details"
                                :input-class="'btn'"
                            />
                        </div>
                    </FormulateForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import InlineSvg from "vue-inline-svg";
    // import AppHero from "@/components/layout/AppHero";

    export default {
        name: 'Setting',
        metaInfo: {
            title: 'Khonsu - Setting'
        },
        components: {
            // InlineSvg,
            // AppHero
        },
        data: function () {
            return {
                newpassword: null,
                oldpassword: null,
                confirmpassword: null,
                username: null,
                useremail: null,


                changePasswordIsActive: false,

                changePasswordSuccessMsg: false,
                changePasswordErrorMsg: false,

            }
        },
        methods: {
            async changePassword() {
                this.changePasswordIsActive = true;
                let email = sessionStorage.getItem('_khonsu_user_email');
                let forgotpasword = await this.$store.dispatch('UserManagement/forgetPassword', {'email': email});
                if (forgotpasword) {

                    let resetPassword = await this.$store.dispatch('UserManagement/resetPassword', {
                        'email': email,
                        'password_old': this.oldpassword,
                        'password': this.newpassword,
                        'password_confirmation': this.confirmpassword,
                        'resetCode': localStorage.getItem('_khonsu_app_resetCode')
                    });
                    if (resetPassword) {
                        this.changePasswordSuccessMsg = true;
                        this.changePasswordErrorMsg = false;
                        this.changePasswordIsActive = false;
                    }
                    if (!resetPassword) {
                        this.changePasswordSuccessMsg = false;
                        this.changePasswordErrorMsg = true;
                        this.changePasswordIsActive = false;
                    }
                }
                if (!forgotpasword) {
                    console.log("could not get resetCode");

                }

            },
            async changeDetails() {
                let Changedetails = await this.$store.dispatch('UserManagement/changeuserdetails',
                    {
                        'name': this.username,
                        'email': this.useremail,
                        'userId':sessionStorage.getItem('user_id'),
                    });
                if (Changedetails) {
                    alert("user Details has been changed successfully");
                }
                if (!Changedetails) {
                    alert("user Details failed to be changed ");

                }
            },

        }

    }
</script>

<style lang="scss">
    #setting-page {
        padding-bottom: 100px

    }

</style>